import { DependencyList, useEffect } from 'react';

export const useEffectCustomAsync = (fn: () => Promise<void>, deps: DependencyList) => {
  useEffect(() => {
    async function asyncFunction() {
      await fn();
    }
    void asyncFunction();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
